import { IDuplicateCaseRepository } from '../ports/outbound/IDuplicateCaseRepository';
import { DuplicateCaseContinueRequest } from '../domain/entities/DuplicateCaseContinueRequest';

export class ContinueCreateDuplicateCaseUseCase {
    constructor(private readonly repository: IDuplicateCaseRepository) { }

    async execute(
        everifyCaseDuplicateId: string,
        request: DuplicateCaseContinueRequest
    ): Promise<void> {
        return this.repository.continueCreateDuplicateCase(
            everifyCaseDuplicateId,
            request
        );
    }
}
